import { Component, OnInit, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-supervisors-chart',
  templateUrl: './supervisors-chart.component.html'
})
export class SupervisorsChartComponent implements OnInit, OnChanges {

  @Input() supervisorsNumberChart;


  public lineChartData:Array<any> = [
    {data: [this.supervisorsNumberChart], label: 'Number'}
  ];
  public lineChartLabels:Array<any> = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  public lineChartOptions:any = {
    responsive: true
  };
  public lineChartColors:Array<any> = [
    {
      backgroundColor: 'rgba(75, 71, 156, 0.6)',
      pointBackgroundColor: 'rgb(75, 71, 156)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(77,83,96,1)'
    }
  ]; 
  public lineChartLegend:boolean = false;
  public lineChartType:string = 'line';

  constructor() { }

 
  ngOnChanges(){
    this.lineChartData[0].data = this.supervisorsNumberChart;
  }

  ngOnInit() {

  }


}
